import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const ResponsiveModal = styled(Modal)`
  .modal-dialog {
    max-width: clamp(360px, 96vw, 960px);
    margin: 1rem auto;
  }

  @media (max-width: 576px) {
    .modal-dialog {
      margin: 0;
      height: 100%;
    }
    .modal-content {
      min-height: 100%;
      border-radius: 0;
    }
  }

  .modal-header {
    padding: clamp(12px, 2.8vw, 20px) clamp(16px, 4vw, 40px);
    background: #fff;
    color: #58079e;
    border-bottom: 1px solid #eee;

    .modal-title {
      width: 100%;
      font-size: clamp(18px, 2.2vw, 22px);
      margin: 0;
    }
  }

  .modal-body {
    padding: clamp(12px, 2.8vw, 20px) clamp(16px, 4vw, 40px);
  }

  .form-grid {
    row-gap: 16px;
  }

  .btn-col {
    display: flex;
    align-items: flex-end;
  }

  @media (max-width: 576px) {
    .btn-col {
      position: sticky;
      bottom: 0;
      z-index: 2;
      padding-top: 8px;
      padding-bottom: max(env(safe-area-inset-bottom), 12px);
      background: linear-gradient(
        to top,
        rgba(255, 255, 255, 1) 60%,
        rgba(255, 255, 255, 0.85) 85%,
        rgba(255, 255, 255, 0) 100%
      );

      button,
      .btn {
        width: 100%;
      }
    }
  }

  .modal-footer {
    padding: clamp(12px, 2.8vw, 20px) clamp(16px, 4vw, 40px);
    color: #58079e;

    button {
      background: ${(props) => props.theme.colors.nav};
      border-color: ${(props) => props.theme.colors.nav};

      &:focus:not(.focus-visible) {
        outline: none !important;
        box-shadow: none !important;
      }
      &:focus-visible {
        outline: 2px solid ${(props) => props.theme.colors.nav} !important;
      }
    }
  }

  .input-qtd {
    outline: none;
    box-sizing: border-box;
    width: 100px;
    line-height: 1.5;
    color: #212529;
    border-radius: 0.25rem;
    border: 2px solid var(--ds-border-neutral, #dfe1e6);
    background-color: #fff;
    padding: 8px 6px;
    font-size: 14px;
    text-align: right;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:focus-visible {
      outline: 2px solid ${(props) => props.theme.colors.nav};
      outline-offset: 1px;
    }
  }

  .is-invalid {
    background-image: none;
    border: 2px solid var(--ds-border-neutral, #dfe1e6);
    border-bottom: 2px solid #cf1919;
    padding: 0.375rem 0.75rem;

    &:focus {
      box-shadow: none;
    }
  }
`;
